import { createApplicationState } from '../applicationState';
import { init as initAuthContext } from '../authContext';
import { init as initEvents } from '../events';
import { initLegacyCallbacks } from '../legacyCallbacks';
import { renderApplication } from '../renderApplication';
import { createContext } from './createContext';

export function runApp() {
  const context = createContext();
  const store = createApplicationState(context);

  initAuthContext(context, store);
  initEvents(context, store);
  initLegacyCallbacks();

  renderApplication({ store, context });
}
